/** De titel van een bezoek: de omschrijving, anders de bezoeker. Editorkop, recordzoeker en de
 *  agenda op het dashboard tonen hem; de lijst zet de omschrijving vooraan. */
export function visitTitle(v: { description?: string | null; visitorName?: string | null }) {
  return v.description?.trim() || v.visitorName?.trim() || ''
}

/** Zonder omschrijving en zonder bezoeker heeft een bezoek geen titel; de server weigert het
 *  dan ook (`VISIT_TITLE_REQUIRED`, visits.router.ts). */
export function visitTitleMissing(values: { description?: unknown; visitorName?: unknown }) {
  return !String(values.description ?? '').trim() && !String(values.visitorName ?? '').trim()
}
